import type {
  FullHeadMprSliceRecordViewsByTileID,
  FullHeadMprSliceTileView,
} from '../config';

export const resolveEffectiveFullHeadMprSliceSelection = ({
  defaultTiles,
  recordsByTileID,
  tiles,
}: {
  defaultTiles: FullHeadMprSliceTileView[];
  recordsByTileID: FullHeadMprSliceRecordViewsByTileID;
  tiles: FullHeadMprSliceTileView[];
}): {
  isTileSelected: (tile: FullHeadMprSliceTileView) => boolean;
  selectedTiles: FullHeadMprSliceTileView[];
} => {
  const isTileSelected = (tile: FullHeadMprSliceTileView): boolean =>
    recordsByTileID[tile.id]?.selectionOverride ??
    defaultTiles.some((defaultTile) => defaultTile.id === tile.id);

  return {
    isTileSelected,
    selectedTiles: tiles.filter(isTileSelected),
  };
};
